import Default from "./Default";
import LeadMagnet from "./LeadMagnet";

/**
 * @typedef {import("@prismicio/client").Content.ContactSlice} ContactSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ContactSlice>} ContactProps
 * @param {ContactProps}
 */
const Contact = ({ slice: { variation, primary, items } }) => {
	switch (variation) {
		case "default":
			return <Default primary={primary} items={items} />;
		case "leadMagnet":
			return <LeadMagnet primary={primary} items={items} />;
		default:
			return null;
	}
};

export default Contact;
